module.exports = __webpack_public_path__ + "static/scan-2-0688d0d15f2ec0bda28e960b42fc0293.jpg";